export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The teacher presented and reviewed course content adequately.",
			},
			{
				id: 2,
				text: "I was able to follow the teacher's pace.",
			},
			{
				id: 3,
				text: "The teacher provided a good learning and working atmosphere.",
			},
			{
				id: 4,
				text: "The teacher provided opportunities to ask questions.",
			},
			{
				id: 5,
				text: "The teacher was always well-prepared.",
			},
			{
				id: 6,
				text: "The teacher was able to explain complicated ideas in an easy to understand way.",
			},
			{
				id: 7,
				text: "It was important to the teacher that the participants beneﬁtted from the course.",
			},
			{
				id: 8,
				text: "The teacher motivated the participants.",
			},
			{
				id: 9,
				text: "The teacher conveyed the content in an interesting way.",
			},
			{
				id: 10,
				text: "The material or media provided by the teacher was helpful.",
			},
			{
				id: 11,
				text: "The objectives of the course were clear to me.",
			},
			{
				id: 12,
				text: "The course was well-structured and understandable.",
			},
			{
				id: 13,
				text: "The structure of the course was logical/easy to follow.",
			},
			{
				id: 14,
				text: "Methods and workload were clear from the course description.",
			},
			{
				id: 15,
				text: "The course set the right priorities.",
			},
			{
				id: 16,
				text: "The topic of the course is relevant.",
			},
			{
				id: 17,
				text: "I believe that I have gained important knowledge from this course.",
			},
			{
				id: 18,
				text: "The skills taught in this course are relevant for my future occupational activities.",
			},
			{
				id: 19,
				text: "The course content met my learning needs.",
			},
			{
				id: 20,
				text: "I have developed skills in the course that are relevant to my professional, academic and/or personal development.",
			},
			{
				id: 21,
				text: "The topics of the course have contributed to the development of my foreign language skills.",
			},
			{
				id: 22,
				text: "I achieved my own learning goals.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 23,
				text: "The diﬃculty of the content was...",
			},
			{
				id: 24,
				text: "The amount of the content was...",
			},
			{
				id: 25,
				text: "The pace of the course was...",
			},
			{
				id: 26,
				text: "The requirements of the course were...",
			},
			{
				id: 27,
				text: "The amount of time required for the course (including preparation and follow-up) was...",
			},
			{
				id: 28,
				text: "Overall, I felt the course to be...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 29,
				text: "I put a lot of time into the preparation and follow-up work of the course.",
			},
			{
				id: 30,
				text: "I put more time into this course than into comparable courses.",
			},
			{
				id: 31,
				text: "I participated in the course actively.",
			},
			{
				id: 32,
				text: "Overall, this was a good course.",
			},
			{
				id: 33,
				text: "I learned a lot in this course.",
			},
			{
				id: 34,
				text: "I would recommend the course to others.",
			},
			{
				id: 35,
				text: "The course fulfilled my expectations.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 36,
				text: "I especially appreciated:",
			},
			{
				id: 37,
				text: "I did not like",
			},
			{
				id: 38,
				text: "What did you hope to gain from this course?",
			},
		],
	},
];
